// Row of secondary action chips for the customer to "carry on shopping"
// after a build summary or basket. Outline pills, smaller than the
// primary CTA above them — they're a pivot, not the next required step.

export function ContinueShoppingChips({
  chips,
  onSelect,
  label = "Carry on shopping?",
}: {
  chips: string[]
  onSelect: (text: string) => void
  label?: string
}) {
  if (!chips.length) return null
  return (
    <div style={{ marginTop: 10 }}>
      <div
        style={{
          fontSize: 10.5,
          fontWeight: 600,
          letterSpacing: 0.6,
          textTransform: "uppercase",
          opacity: 0.55,
          marginBottom: 6,
          textAlign: "center",
        }}
      >
        {label}
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 6,
          justifyContent: "center",
        }}
      >
        {chips.map((c, i) => (
          <button
            key={i}
            type="button"
            onClick={() => onSelect(c)}
            style={{
              padding: "5px 11px",
              borderRadius: 999,
              border: "1px solid rgba(255,255,255,0.18)",
              background: "transparent",
              color: "rgba(255,255,255,0.78)",
              font: "inherit",
              fontSize: 11.5,
              fontWeight: 500,
              cursor: "pointer",
              transition:
                "background 120ms ease, border-color 120ms ease, color 120ms ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.08)"
              e.currentTarget.style.borderColor = "rgba(109, 195, 247, 0.55)"
              e.currentTarget.style.color = "rgba(255,255,255,0.96)"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent"
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.18)"
              e.currentTarget.style.color = "rgba(255,255,255,0.78)"
            }}
          >
            {c}
          </button>
        ))}
      </div>
    </div>
  )
}
